import React from 'react';
import plus from '../assets/ComCleanPlus.png'
import { useAppContext } from '../AppContext';

const CONTENT = {
  en: {
    start: "Get Started Today!",
    rest: "Pick your plan, we do the rest!",
    leads: "Leads",
    seeRealLeads: "See Real Leads in Your Area Before You Buy",
    noCommitment: "No commitment. Check what's available in your ZIP code instantly.",
    checkAvailability: "Check Availability",
  },
  es: {
    start: "¡Comienza hoy!",
    rest: "Elige tu plan, nosotros hacemos el resto!",
    leads: "Leads",
    seeRealLeads: "Ve leads reales en tu área antes de comprar",
    noCommitment: "Sin compromiso. Consulta al instante qué hay disponible en tu código postal.",
    checkAvailability: "Verificar disponibilidad",
  },
};

const GetStarted = ({ lang = "en" }) => {
  const { buyNow, setBuyNow, leadsCount, setLeadsCount, setSelectedPrice } = useAppContext();
  const t = CONTENT[lang] || CONTENT.en;

  const handleCheckAvailability = () => {
    setBuyNow("form");
    // Let React render the form, then scroll to it smoothly (avoids jerk and ensures form is visible)
    requestAnimationFrame(() => {
      setTimeout(() => {
        const el = document.getElementById("checkout-form-anchor");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: 0, behavior: "smooth" });
      }, 50);
    });
  };

  const plans = [
  { qty: 50, price: 39 },
  { qty: 200, price: 99 },
  { qty: 500, price: 199 },
];

  return (
    <section className="py-16 bg-[#DBE4E5]">
      <div className="container mx-auto max-w-5xl px-4 text-center">
        <h2 className="text-2xl font-bold text-[#1465B7] mb-4">
          <span className='text-[#26A94A] font-semibold'>{t.start}</span> {t.rest}
        </h2>
        {/* <p className="text-2xl text-gray-600 mb-8">
          Only $199 for 500 leads. Instant Download!
        </p>

<div className='mt-20'>
        <button className="bg-[#FAF26B] text-[#1465B7] hover:bg-yellow-300 font-bold py-5 px-12 shadow-xl rounded-full text-lg cursor-pointer " style={{color: '#1465B7', fontSize:'24px'}}
            onClick={() => {
      setBuyNow('payment');  // Set the state to true
      window.scrollTo({ top: 0, behavior: 'smooth' });  // Scroll to top of the page
    }}
        >
          Get Your List
        </button>
      </div> */}

  <div className="w-full flex justify-center">
  <div className="w-full max-w-md md:max-w-3xl">
    {/* ✅ Mobile (same as your current UI) */}
    <div className="space-y-5 md:hidden">
      {plans.map((p) => (
        <div
          key={p.qty}
          className="
            grid grid-cols-3 items-center
            bg-[#BFEAF2]
            border-[3px] border-[#1E8E2E]
            rounded-[22px]
            px-6 py-4
          "
        >
          {/* Left number */}
          <div className="text-left">
            <span
              className="
                text-2xl leading-none font-extrabold
                text-[#EAFB55]
                drop-shadow-[2px_2px_0px_#2E7D32]
              "
            >
              {p.qty}
            </span>
          </div>

          {/* Center label */}
          <div className="text-center">
            <span className="text-2xl leading-none font-extrabold text-[#1F5FBF]">
              {t.leads}
            </span>
          </div>

          {/* Right price */}
          <div className="text-right">
            <span className="text-2xl leading-none font-extrabold text-[#1E8E2E]">
              ${p.price}
            </span>
          </div>
        </div>
      ))}
    </div>

    {/* ✅ Laptop/Desktop (as screenshot) */}
    <div
      className="
        hidden md:grid
        grid-cols-3
        bg-[#BFEAF2]
        border-[3px] border-[#1E8E2E]
        rounded-[22px]
        overflow-hidden
      "
    >
      {plans.map((p, i) => (
        <div
          key={p.qty}
          className={`
            flex flex-col items-center justify-center
            px-3 py-1
            ${i !== plans.length - 1 ? "border-r-[3px] border-[#1E8E2E]" : ""}
          `}
        >
          <span
            className="
              text-2xl leading-none font-extrabold
              text-[#EAFB55]
              drop-shadow-[2px_2px_0px_#2E7D32]
            "
          >
            {p.qty}
          </span>

          <div className="mt-1 gap-2 ">
            <span className="text-2xl leading-none font-extrabold text-[#1F5FBF]">
              {t.leads}
            </span>
            <div className="text-2xl leading-none font-extrabold text-[#1E8E2E] my-2">
              ${p.price}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

        {/* See Real Leads section (same as top CTA) */}
        <div className="mt-10 w-full max-w-lg mx-auto">
          <p className="text-xl font-bold text-[#1465B7] mb-2">
            {t.seeRealLeads}
          </p>
          <p className="text-sm text-gray-500 mb-6">
            {t.noCommitment}
          </p>
          <div
            className="w-full bg-[#BFEAF2] border-[3px] border-[#26A94A] rounded-xl overflow-hidden grid grid-cols-3 mb-6"
          >
            {plans.map((p, idx) => (
              <button
                key={p.qty}
                type="button"
                onClick={() => {
                  setLeadsCount(p.qty);
                  setSelectedPrice(p.price * 100);
                }}
                className={`py-2 flex flex-col items-center justify-center transition cursor-pointer
                  ${idx !== 0 ? "border-l-[3px] border-[#26A94A]" : ""}
                  ${leadsCount === p.qty ? "bg-[#85C1CF]" : ""}
                `}
              >
                <span className="text-lg font-extrabold leading-none text-[#EAFB55] drop-shadow-[1.5px_1.5px_0px_#2E7D32]">
                  {p.qty}
                </span>
                <span className="text-sm font-extrabold leading-none text-[#1465B7]">{t.leads}</span>
                <span className="text-base sm:text-lg font-extrabold leading-none text-[#26A94A] my-1">
                  ${p.price}
                </span>
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={handleCheckAvailability}
            className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-[#1465B7] font-bold py-4 rounded-full transition-colors border-[3px] border-[#26A94A] cursor-pointer"
            style={{ fontSize: "24px", color: "#1465B7" }}
          >
            {t.checkAvailability}
          </button>
          <p className="mt-3 text-xs text-gray-400">
            🔒 We'll never spam you. One-time confirmation only.
          </p>
        </div>



      </div>
    </section>
  );
};

export default GetStarted;